export const WatermarkConstants = {
  font: 'bold 10px Arial Black, sans serif',
  fillStyle: 'white',
  strokeStyle: 'black',
  shadow: 'drop-shadow(0 0.5px 2px rgba(0,0,0,1))',
  textAlign: 'center',
  lineWidth: 2,
  miterLimit: 2,
}
